var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"rounded-full focus:outline-none circle-button",class:{
    'border border-secondary': _vm.bordered,
    'bg-secondary-300 text-secondary-400 cursor-not-allowed': _vm.disabled,
  },attrs:{"disabled":_vm.disabled},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('click')}}},[_vm._t("default"),(_vm.$slots.icon)?_c('div',{staticClass:"flex items-center m-auto"},[_vm._t("icon")],2):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }